import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { useTranslation } from "react-i18next";
import { MyInstrumentStyled } from "./styled";
import { Buttons, Icons } from "components";

const MyInstrument = ({ theme_standard, data, onAdd, onDetail, onEdit }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { t, i18n } = useTranslation(["profile", "common"]);

  return (
    <>
      <MyInstrumentStyled lang={i18n.language}>
        <div className={customClass}>
          <div className="title_row_wrap">
            <div className="title">{t("My Instrument", { ns: "profile" })}</div>
          </div>
          {data && data.length > 0 ? (
            data.map((e, i) => (
              <div className="data_wrap" key={i}>
                <div className="data_title">
                  {i18n.language === "en" ? e.product_en : e.product_th}
                  <div className="edit_btn">
                    <Buttons.BgStandard
                      onClick={() => onEdit(e)}
                      theme_white_purple
                      height="30px"
                      label={i18n.language === "en" ? "Edit" : "แก้ไข"}
                    />
                  </div>
                </div>
                <div className="data_desc_list">
                  <div className="data_desc">
                    <div className="section">Description :</div>
                    <div className="data">{e.brand}</div>
                  </div>
                  <div className="data_desc">
                    <div className="section">Description Line 2 :</div>
                    <div className="data">{e.model}</div>
                  </div>
                  <div className="data_desc">
                    <div className="section">Description Line 3 :</div>
                    <div className="data">{e.series}</div>
                  </div>
                  <div className="data_desc mb10">
                    <div className="section">Item Number/Serial No :</div>
                    <div className="data">{e.serial_no}</div>
                  </div>
                </div>
                {e.is_maintenance && (
                  <div className="btn_wrap" onClick={() => onDetail(e._id)}>
                    <div className="btn">{t("Details", { ns: "common" }) + " >"}</div>
                  </div>
                )}
                {i !== data.length - 1 && <div className="line" />}
              </div>
            ))
          ) : (
            <>
              <div className="desc_sec">
                {i18n.language === "en"
                  ? "Let us get to know you better to offer exclusive activities,tailored to your preferences and to build your instrument history."
                  : "ให้เรารู้จักคุณมากขึ้น เพื่อนำเสนอ กิจกรรมสุดพิเศษ\nสำหรับความชอบเฉพาะของคุณ และ สร้างประวัติเครื่องดนตรี"}
              </div>
            </>
          )}
        </div>
        <div className="btn_add_wrap">
          <Buttons.BgIconPrefix
            theme_white_purple
            icon={<Icons.Add color="#4B247E" />}
            label={
              t("Add My Instrument", { ns: "profile" })
            }
            onClick={onAdd}
          />
        </div>
      </MyInstrumentStyled>
    </>
  );
};

MyInstrument.propTypes = {};

export default MyInstrument;
